import { useApi } from '#/api/fetch-api';
import { cancelAllOrders } from '#/api/orders';

import { useTranslation } from '#/features/localization/utils';

import toast from '#/components/common/toast';
import ButtonLink from '#/components/shared/ButtonLink';

export default function CancelAllOrders() {
  const [{ isLoading }, exec] = useApi(cancelAllOrders);
  const { t } = useTranslation();

  const handleClick = () => {
    exec({}, (resp) => {
      if (!resp.ok) {
        toast.error(resp.message);
      }
    });
  };

  return (
    <ButtonLink disabled={isLoading} onClick={handleClick}>
      {t('Cancel All')}
    </ButtonLink>
  );
}
